import { useTranslation } from "react-i18next";
import { styled } from "@mui/material";
import NormalText from "../Typography/NormalText";

const ToastContainerStyled = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "0.25rem",
  "& .toast-title": {
    fontWeight: 600,
  },
  "& .toast-message": {
    fontSize: "14px",
  },
  "& .toast-link": {
    width: "max-content",
    textDecoration: "none",
    color: theme.palette.primary.main,
    "&:hover": {
      textDecoration: "underline",
    },
    "& p": {
      fontWeight: 500,
    },
  },
}));

const ToastMessage = ({ title, message, shouldReload }) => {
  const { t } = useTranslation();

  return (
    <ToastContainerStyled>
      {title && <NormalText className="toast-title">{title}</NormalText>}
      <span className="toast-message">{message}</span>
      {shouldReload && (
        <button
          onClick={() => window.location.reload()}
          className="btn-unstyled toast-link"
        >
          <NormalText>{t("Global.ReloadPage")}</NormalText>
        </button>
      )}
    </ToastContainerStyled>
  );
};

export default ToastMessage;
